import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const whatslotPlugin = createPlugin({
  id: 'whatslot',
  routes: {
    root: rootRouteRef,
  },
});

export const WhatslotPage = whatslotPlugin.provide(
  createRoutableExtension({
    name: 'WhatslotPage',
    component: () =>
      import('./components/WhatslotHeader').then(m => m.WhatslotHeader),
    mountPoint: rootRouteRef,
  }),
);
